function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var VideoPlayerEvent = function VideoPlayerEvent() {
  _classCallCheck(this, VideoPlayerEvent);
  this.bookingNumber = void 0;
  this.timestamp = void 0;
  this.link = void 0;
  this.identifier = void 0;
};

export { VideoPlayerEvent as default };
//# sourceMappingURL=VideoPlayerEvent.js.map
